export const useDragAndDrop = (dragApi) => {
  return {
    onDragStart: (e) => {
      e.target.blur()
      const draggedIndex = e.target.getAttribute('drag-index')
      dragApi.onDragStart(draggedIndex)
    },
    onDragOver: (e) => {
      e.preventDefault()
    },
    onDragEnter: (e) => {
      e.target.focus()
      const dropIndex = e.target.getAttribute('drag-index')
      dragApi.onDragEnter(dropIndex)
    },
    onDrop: (e) => {
      e.preventDefault()
      dragApi.onDrop()
    },
  }
}
